export const APPT_STATUSES = [
  { value: "scheduled", label: "Scheduled", badge: "bg-sky-50 text-sky-700 hover:bg-sky-50" },
  { value: "confirmed", label: "Confirmed", badge: "bg-emerald-50 text-emerald-700 hover:bg-emerald-50" },
  { value: "completed", label: "Completed", badge: "bg-teal-50 text-teal-700 hover:bg-teal-50" },
  { value: "cancelled", label: "Cancelled", badge: "bg-red-50 text-red-600 hover:bg-red-50" },
  { value: "no_show", label: "No-show", badge: "bg-amber-50 text-amber-600 hover:bg-amber-50" },
  { value: "rescheduled", label: "Rescheduled", badge: "bg-violet-50 text-violet-700 hover:bg-violet-50" },
];

export const CONVO_CHANNELS = ["WhatsApp", "Phone", "Website", "Manual/Internal"];
export const CONVO_STATUSES = [
  { value: "open", label: "Open", badge: "bg-emerald-50 text-emerald-700" },
  { value: "pending", label: "Pending", badge: "bg-amber-50 text-amber-600" },
  { value: "closed", label: "Closed", badge: "bg-slate-100 text-slate-500" },
];

export const FOLLOWUP_TYPES = ["Call", "WhatsApp", "Appointment Reminder", "General Follow-up"];
export const FOLLOWUP_STATUSES = [
  { value: "pending", label: "Pending", badge: "bg-sky-50 text-sky-700 hover:bg-sky-50" },
  { value: "completed", label: "Completed", badge: "bg-emerald-50 text-emerald-700 hover:bg-emerald-50" },
  { value: "cancelled", label: "Cancelled", badge: "bg-slate-100 text-slate-500 hover:bg-slate-100" },
];
export const FOLLOWUP_PRIORITIES = [
  { value: "high", label: "High", badge: "bg-red-50 text-red-600" },
  { value: "medium", label: "Medium", badge: "bg-amber-50 text-amber-600" },
  { value: "low", label: "Low", badge: "bg-slate-100 text-slate-500" },
];
export const FOLLOWUP_OUTCOMES = [
  "Interested", "No Answer", "Callback Requested", "Appointment Booked",
  "Not Interested", "Rescheduled", "Other",
];

export const WEEKDAYS = [
  { key: "monday", label: "Monday" },
  { key: "tuesday", label: "Tuesday" },
  { key: "wednesday", label: "Wednesday" },
  { key: "thursday", label: "Thursday" },
  { key: "friday", label: "Friday" },
  { key: "saturday", label: "Saturday" },
  { key: "sunday", label: "Sunday" },
];

const findMeta = (list, v) => list.find((x) => x.value === v) || { value: v, label: v, badge: "bg-slate-100 text-slate-600" };
export const apptMeta = (v) => findMeta(APPT_STATUSES, v);
export const convoStatusMeta = (v) => findMeta(CONVO_STATUSES, v);
export const followupStatusMeta = (v) => findMeta(FOLLOWUP_STATUSES, v);
export const followupPriorityMeta = (v) => findMeta(FOLLOWUP_PRIORITIES, v);

export const KB_CATEGORIES = [
  "FAQs", "Services", "Pricing", "Doctors", "Insurance", "Clinic Policies",
  "Treatment Information", "Packages", "Locations & Timings", "General Information",
];

export const CONVO_STATES = [
  { value: "ai_active", label: "AI Active", badge: "bg-emerald-50 text-emerald-700 hover:bg-emerald-50" },
  { value: "human_required", label: "Human Required", badge: "bg-amber-50 text-amber-600 hover:bg-amber-50" },
  { value: "human_active", label: "Human Active", badge: "bg-violet-50 text-violet-700 hover:bg-violet-50" },
  { value: "resolved", label: "Resolved", badge: "bg-slate-100 text-slate-500 hover:bg-slate-100" },
];
export const convoStateMeta = (v) => CONVO_STATES.find((s) => s.value === v) || CONVO_STATES[0];

export function initials(name = "") {
  return name.split(" ").map((n) => n[0]).slice(0, 2).join("").toUpperCase();
}

export function fmtDate(iso) {
  if (!iso) return "—";
  try { return new Date(iso).toLocaleDateString(undefined, { day: "2-digit", month: "short", year: "numeric" }); }
  catch { return iso; }
}
export function fmtDateTime(iso) {
  if (!iso) return "—";
  try { return new Date(iso).toLocaleString(undefined, { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }); }
  catch { return iso; }
}
